/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, InteractionManager, Platform } from 'react-native';
import Images from '../images';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { JDDevice, JDText, JDImage, JDTouchable } from '@jdreact/jdreact-core-lib';
import InfoTitle from './InfoTitle';
import Store from '../services/goodsContrastPageStore/store';
import { ITicket, IPriceItem, IPriceTab } from '../services/goodsContrastPageStore/domain';
//埋点
import { logClick, ContrastBenefits, ContrastBenefitsExpo } from '../mta/MtaService';
import Loading from './Loading';
import FlexImage from './FlexImage';
const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    paddingLeft: getRpx(37),
    paddingTop: getRpx(38),
  },
  commonLine: {
    width: 1,
    height: getRpx(40),
    backgroundColor: '#F2F2F2',
    marginLeft: getRpx(35),
  },
  contrastInfo: {},
  contrastItem: {
    marginBottom: getRpx(52),
  },
  taxation: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  paramsItem: {
    justifyContent: 'space-between',
    width: getRpx(322),
    minHeight: getRpx(60),
    paddingLeft: getRpx(35),
  },
  taxationItem: {
    flexDirection: 'row',
  },
  taxationText: {
    fontSize: getFontSize(26),
    lineHeight: getRpx(37),
  },
  price: {
    flexDirection: 'row',
  },
  priceItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  priceList: {
    flexDirection: 'column',
  },
  priceText: {
    height: getRpx(43),
    lineHeight: getRpx(43),
    fontSize: getRpx(36),
    color: '#262626',
    fontWeight: 'bold',
    marginBottom: getRpx(10),
  },
  pricePlusText: {
    height: getRpx(33),
    lineHeight: getRpx(33),
    fontSize: getFontSize(24),
    color: '#262626',
    fontWeight: 'bold',
    marginRight: getRpx(4),
  },
  pricePlus: {
    width: getRpx(60),
    height: getRpx(20),
  },
  plus: {
    flexDirection: 'row',
    alignItems: 'center',
    height: getRpx(33),
  },
  priceArrow: {
    width: Platform.OS == 'android' ? getRpx(8) : getRpx(6),
    height: getRpx(16),
  },
  tagList: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: getRpx(6),
    //紧贴左侧某些安卓手机会被截掉一边
    paddingLeft: getRpx(6),
    paddingBottom: getRpx(10),
  },
  tagItem: {
    paddingLeft: getRpx(4),
    paddingRight: getRpx(4),
    paddingBottom: getRpx(3),
    paddingTop: getRpx(3),
    borderRadius: getRpx(4),
    borderWidth: JDDevice.getDpx(1),
    borderStyle: 'solid',
    borderColor: '#FF8373',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: getRpx(12),
  },
  tagItemText: {
    height: getRpx(20),
    includeFontPadding: false,
    textAlignVertical: 'center',
    fontSize: getRpx(18),
    color: '#FF8373',
  },
  whiteStripe: {
    flexDirection: 'row',
  },
  whiteStripeItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  whiteStripeList: {},
  stagesText: {
    color: '#262626',
    fontSize: getRpx(26),
    height: getRpx(37),
    lineHeight: getRpx(37),
    fontWeight: 'bold',
  },
  seriveText: {
    color: '#8C8C8C',
    fontSize: getRpx(22),
    height: getRpx(30),
    lineHeight: getRpx(30),
  },
  free: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  freeTag: {
    justifyContent: 'center',
    alignItems: 'center',
    width: getRpx(48),
    height: getRpx(26),
    backgroundColor: '#FCEDEB',
    borderRadius: getRpx(4),
    marginLeft: getRpx(8),
  },
  freeTagText: {
    color: '#F2270C',
    height: getRpx(20),
    lineHeight: getRpx(20),
    fontSize: getRpx(20),
  },
  freeText: {
    color: '#F2270C',
    fontSize: getRpx(26),
    height: getRpx(37),
    lineHeight: getRpx(37),
  },
  freight: {
    flexDirection: 'row',
  },
  freightList: {
    flexDirection: 'column',
    flexWrap: 'wrap',
    maxWidth: getRpx(250),
  },
  freightItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  alignTop: {
    alignItems: 'flex-start',
  },
  alignCenter: {
    alignSelf: 'center',
  },
  freightItemText: {
    fontSize: getRpx(26),
    lineHeight: getRpx(37),
    color: '#262626',
  },
});
interface IStoreProps {
  store: {
    tabCtrlIndex: number;
    entrySku: string;
    priceTab: IPriceTab;
    SamePropsCheck: boolean;
    slideUpTicketDialog: (T: ITicket | never[], index: number) => void;
  };
}
interface IProps extends IStoreProps {
  isReadOnly: boolean;
  index: number;
}
interface IState {
  priceTab: IPriceTab | null;
}
class TabContAppearancePrice extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      priceTab: null,
    };
  }
  componentDidMount() {
    const {
      store: { entrySku, priceTab },
    } = this.props;
    setTimeout(() => {
      InteractionManager.runAfterInteractions(() => {
        this.setState({ priceTab });
      });
    }, 0);
    logClick({
      event_id: ContrastBenefitsExpo,
      event_param: '',
      page_param: entrySku,
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.store.priceTab) {
      this.setState({ priceTab: nextProps.store.priceTab });
    }
  }
  slideUpTicketDialog = (price: IPriceItem, index: number) => {
    // 只读模式下隐藏点击
    // if (this.props.isReadOnly || !price.underIcons) return;
    if (!price.underIcons) return;
    logClick({
      event_id: ContrastBenefits,
      event_param: '',
      page_param: this.props.store.entrySku,
    });
    let ticket = Object.assign({ sku: price.skuId }, price.promotion);
    this.props.store.slideUpTicketDialog(ticket, index);
  };
  render() {
    const { store, isReadOnly, index } = this.props;
    const { SamePropsCheck, tabCtrlIndex } = store;
    const { priceTab } = this.state;
    let hideSame = SamePropsCheck && tabCtrlIndex === index;
    if (!priceTab) {
      return (
        <View style={{ height: getRpx(500) }}>
          <Loading />
        </View>
      );
    }
    return (
      <View style={styles.wrap}>
        {hideSame && priceTab.price && priceTab.price.hiddenFlag ? null : (
          <>
            {priceTab.price && priceTab.price.prices && priceTab.price.prices.length > 0 ? (
              <View style={styles.contrastItem}>
                <InfoTitle title={'价格'} marginBottom={20} />
                <View style={styles.price}>
                  {priceTab.price &&
                    priceTab.price.prices &&
                    priceTab.price.prices.map((price: IPriceItem, index: number) => {
                      return (
                        <JDTouchable onPress={this.slideUpTicketDialog.bind(this, price, index)}>
                          <View style={[styles.priceItem, styles.paramsItem]} key={price.skuId}>
                            <View style={styles.priceList}>
                              <JDText style={styles.priceText}>{price.jdPrice ? price.jdPrice : '-'}</JDText>
                              {/* plus start */}
                              {price.secondPrice ? (
                                <View style={styles.plus}>
                                  <JDText style={styles.pricePlusText}>{price.secondPrice}</JDText>
                                  <FlexImage height={getRpx(20)} uri={price.icon}></FlexImage>
                                </View>
                              ) : null}
                              {/* plus end */}

                              {/* 优惠券 start */}
                              <View style={styles.tagList}>
                                {price.underIcons &&
                                  price.underIcons.map((i: string) => {
                                    return (
                                      <View style={styles.tagItem} key={i}>
                                        <JDText style={styles.tagItemText}>{i}</JDText>
                                      </View>
                                    );
                                  })}

                                {!isReadOnly && price.underIcons ? (
                                  <JDImage source={Images.contrast.priceArrow} style={styles.priceArrow}></JDImage>
                                ) : null}
                              </View>
                              {/* 优惠券 end */}
                            </View>
                            {index === priceTab.price.prices.length - 1 ? null : (
                              <View style={styles.commonLine}></View>
                            )}
                          </View>
                        </JDTouchable>
                      );
                    })}
                </View>
              </View>
            ) : null}
          </>
        )}
        {hideSame && priceTab.tax && priceTab.tax.hiddenFlag ? null : (
          <>
            {priceTab.tax && priceTab.tax.taxes && priceTab.tax.taxes.length > 0 ? (
              <View style={styles.contrastItem}>
                <InfoTitle title={'税费'} marginBottom={20} />
                <View style={styles.taxation}>
                  {priceTab.tax &&
                    priceTab.tax.taxes &&
                    priceTab.tax.taxes.map((t: string, idx: number) => {
                      return (
                        <View style={[styles.taxationItem, styles.paramsItem]} key={t + idx}>
                          <JDText style={styles.taxationText}>{t ? t : '-'}</JDText>
                          {idx === priceTab.tax.taxes.length - 1 ? null : <View style={styles.commonLine}></View>}
                        </View>
                      );
                    })}
                </View>
              </View>
            ) : null}
          </>
        )}
        {hideSame && priceTab.fare && priceTab.fare.hiddenFlag ? null : (
          <>
            {priceTab.fare && priceTab.fare.fares && priceTab.fare.fares.length > 0 ? (
              <View style={styles.contrastItem}>
                <InfoTitle title={'运费'} marginBottom={20} />
                <View style={styles.freight}>
                  {priceTab.fare &&
                    priceTab.fare.fares &&
                    priceTab.fare.fares.map((f: string, idx: number) => {
                      return (
                        <View style={[styles.freightItem, styles.paramsItem]} key={f}>
                          <View style={styles.freightList}>
                            <JDText style={styles.freightItemText}>{f ? f : '-'}</JDText>
                          </View>
                          {idx === priceTab.fare.fares.length - 1 ? null : <View style={styles.commonLine}></View>}
                        </View>
                      );
                    })}
                </View>
              </View>
            ) : null}
          </>
        )}
        {hideSame && priceTab.gift && priceTab.gift.hiddenFlag ? null : (
          <>
            {priceTab.gift && priceTab.gift.gifts && priceTab.gift.gifts.length > 0 ? (
              <View style={styles.contrastItem}>
                <InfoTitle title={'赠品'} marginBottom={20} />
                <View style={styles.freight}>
                  {priceTab.gift &&
                    priceTab.gift.gifts &&
                    priceTab.gift.gifts.map((g, idx) => {
                      return (
                        <View style={[styles.freightItem, styles.paramsItem, styles.alignTop]} key={g}>
                          <View style={styles.freightList}>
                            {g.length > 0 ? (
                              g.map((gift) => {
                                return (
                                  <JDText style={styles.freightItemText} key={gift}>
                                    {gift ? gift : '-'}
                                  </JDText>
                                );
                              })
                            ) : (
                              <JDText style={styles.freightItemText}>-</JDText>
                            )}
                          </View>
                          {idx === priceTab.gift.gifts.length - 1 ? null : (
                            <View style={[styles.commonLine, styles.alignCenter]}></View>
                          )}
                        </View>
                      );
                    })}
                </View>
              </View>
            ) : null}
          </>
        )}
      </View>
    );
  }
}

const TabContAppearancePriceOberver = observer(TabContAppearancePrice);
const TabContAppearancePriceWapper = (props: IProps) => <TabContAppearancePriceOberver {...props} store={Store} />;
export default TabContAppearancePriceWapper;
